import { env } from "@/env.mjs";

const site_url = env.NEXT_PUBLIC_APP_URL;

export interface SiteConfig {
  name: string
  title: string
  description: string
  url: string
  ogImage: string
  author: string
  creator: string
  links: {
    twitter: string,
    github: string,
  },
  subtitle: string,  // 改为 string 类型，这样就可以接受任意字符串
};

export const enSiteConfig: SiteConfig = {
  name: "AIchimpNAV",
  title: "Filter 95% junk info, AI Chimp navigation premium gems",
  description:
    "Filter out truly innovative masterpieces from a vast array of products, making every choice effortless and worry-free.",
  url: site_url,
  ogImage: `${site_url}/og.png`,
  author: "AIchimp",    
  creator: "AIchimp",   
  links: {
    twitter: "https://x.com/aichimpnav",
    github: "https://github.com/aichimp",
  },
  subtitle: "Filter 95% junk info, AI Chimp navigation premium gems",
}

export const zhSiteConfig: SiteConfig = {
  name: "AI猩导航",
  title: "过滤95%无效信息，AI猩导航直达宝藏精品",
  description:
    "从海量产品中筛选出真正值得尝试的创新之作，让你的每一次选择都省心又放心",
  url: site_url,
  ogImage: `${site_url}/og.png`,
  author: "AIchimp",    // 添加作者字段
  creator: "AIchimp",   // 添加创建者字段
  links: {
    twitter: "https://x.com/aichimpnav",
    github: "https://github.com/aichimp",
  },
  subtitle: "过滤95%无效信息，AI猩导航直达宝藏精品",
};

export const AllSiteConfigs: {[key: string]: SiteConfig} = {
  en: enSiteConfig,
  zh: zhSiteConfig,
}